import { AQSI_KIND } from '../features/connection-form/model/settings'
import { AQSI_RIGHTS } from '../shared/model/rights'
import { PURPOSE_CAPABILITY, SALES_READ_CAPABILITY } from '../features/source/model/types'
import { AQSI_WINDOWS } from './registerWindows'

/**
 * Входы в окна AQSI из карточки ресурса Platform (UA1c п. 7): кнопка → окно
 * кабинета с rid этого ресурса, минуя выбор кабинета. Объект той же формы, что
 * `ResourceEntriesExtension` пакета `platform-ui` (пакеты друг друга не
 * импортируют; совместимость проверяет компилятор в `apps/web`). Право — то
 * же, по которому кабинет попадает в выбор окна.
 */
export const aqsiResourceEntries = {
  kind: AQSI_KIND,
  entries: [
    { window: AQSI_WINDOWS.rmk, label: 'РМК', capability: PURPOSE_CAPABILITY.rmk },
    { window: AQSI_WINDOWS.catalog, label: 'Каталог', capability: PURPOSE_CAPABILITY.catalog },
    { window: AQSI_WINDOWS.receipts, label: 'Чеки', capability: PURPOSE_CAPABILITY.receipts },
    { window: AQSI_WINDOWS.salesStatistics, label: 'Статистика по продажам', capability: SALES_READ_CAPABILITY },
    { window: AQSI_WINDOWS.shifts, label: 'Смены', capability: PURPOSE_CAPABILITY.receipts },
    { window: AQSI_WINDOWS.delivery, label: 'Доставка', capability: AQSI_RIGHTS.deliveryRead },
    { window: AQSI_WINDOWS.createDefaults, label: 'Создание по умолчанию', capability: AQSI_RIGHTS.catalogWrite },
  ],
} as const
